module.exports = __webpack_public_path__ + "media/steps/getauto_car_bcg-scaled-6f977c96.png";